import React from 'react';
import './css/PictureDrawer.css';

export function PictureDrawer({ images, selectedFiles, fileClick }) {
    function fileStyle(file) {
        if (selectedFiles.find(f => f == file))
            return { borderRadius: "10px", background: "rgba(74, 125, 255, 0.5)" }
        else
            return {}
    }

    const updatePictureDrawer = () => {
        const pictureSet = [];
        for (let i = 0; i < images.length / 8 + 1; i++) {
            const pictureRoll = [];
            for (let j = 0; j < 8; j++) {
                if (i * 8 + j >= images.length) {
                    break;
                }
                pictureRoll.push(
                    <div
                        className="file-preview" key={`file-${i * 8 + j}`}
                        onClick={() => { fileClick(images[i * 8 + j]) }}
                        style={fileStyle(images[i * 8 + j])}>
                        <div className="picture-preview">
                            <div className="component-1">
                                <img src={images[i * 8 + j].imageSrc} className="image-horizontal" />
                            </div>
                        </div>
                        <div className="text-10pt">
                            <div className="file-name">
                                {images[i * 8 + j].name.replace(/\.[^/.]+$/, "")}
                            </div>
                        </div>
                    </div>
                )
            }
            pictureSet.push(
                <div className="file-roll" key={`file-roll-${i}`}>
                    {pictureRoll}
                </div>
            )
        }
        return pictureSet;
    }

    return (
        <div className="drawer-box">
            <div className="file-set" id="file-set">
                {updatePictureDrawer()}
            </div>
            <div className="scroll-bar">
            </div>
        </div>
    )
}

